import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { API } from "@/lib/api";

const CurrencyContext = createContext({ currency: "hkd" });

export const useCurrency = () => useContext(CurrencyContext);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("hkd");

  useEffect(() => {
    let cancelled = false;

    const loadCurrency = async () => {
      try {
        const { data } = await API.get("/payments/currency");
        const code = (data?.currency || "hkd").toLowerCase();
        if (!cancelled && code) setCurrency(code);
      } catch {
        // Keep hkd fallback if the API is unavailable.
      }
    };

    loadCurrency();
    const onChanged = () => loadCurrency();
    window.addEventListener("gabriel-consultant:currency-changed", onChanged);
    return () => {
      cancelled = true;
      window.removeEventListener("gabriel-consultant:currency-changed", onChanged);
    };
  }, []);

  const value = useMemo(() => ({ currency }), [currency]);

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
